import { B2bProgress } from 'src/components/biz-b2b-progress';

export default B2bProgress;
